import React, { Component } from 'react';
import './css/docs.css';


export default class MDDocs extends Component{

  constructor(props){
    super(props);

    this.state = {
      testHtml: ''
    };

    if (this.props.clientId){
      this.state.clientId = this.props.clientId;
    } else {      
      if (this.props.apps && this.props.apps.length > 0){
        this.state.clientId = this.props.apps[0].clientId;
      }
    }
  }

  componentDidMount(){
    this.showDocs(this.state.clientId);
  }

  getFramework(clientId){
    return this.props.apps.find(el => {
      return (el.clientId == clientId);
    }).framework;
  }

  showDocs(clientId){
    this.setState({
      testHtml: '<h1>Loading...</h1>'
    });
    this.fetchDocs(this.getFramework(clientId));
  }

  fetchDocs(framework){
    fetch(`/ajax/getDocs.php?framework=${framework}`)
      .then(rsp => rsp.text())
      .then(body => {
        // cut intro text
        return body.substr(body.indexOf('</p>')+4);
      })
      .then(body => {
        console.log(body);
        let converter = new window.showdown.Converter();

        this.setState({
          testHtml: converter.makeHtml(body)
        });
      });
  }

  setApp(e){

    let newClientId = e.target.value;
    let currentFramework = this.getFramework(
      this.state.clientId
    );
    let newFramework = this.getFramework(newClientId);

    if (newFramework != currentFramework){
      this.showDocs(newClientId);
    }
    
    this.setState({
      clientId: newClientId
    });
  }
  
  render() {
    return (
      <div id="docs">
        <div id="docs-text">
          <h2 id="api-key">App key</h2>

          <label className="control-label">
            Select App:
          </label>
          <select className="form-control"
                  onChange={this.setApp.bind(this)}
                  value={this.state.clientId}>
            {this.props.apps.map((app,idx) => {
              return (
                <option
                  key={idx}
                  value={app.clientId}>
                  {app.name}
                </option>);
            })}
      </select>
        <pre>
        Api Key: {this.state.clientId}
      </pre>

        <div dangerouslySetInnerHTML={{__html: this.state.testHtml}} />
        </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MDDocs.js